import React, { Component, useEffect, useState } from "react";
import ComponentTopupMobile from "./ComponentTopupMobile";
import ComponentTopupWeb from "./ComponentTopupWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";

const ComponentTopup = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Top Up",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentTopupWeb></ComponentTopupWeb>
      </BrowserView>
      <MobileView>
        <ComponentTopupMobile></ComponentTopupMobile>
      </MobileView>
    </>
  );
};

export default ComponentTopup;
